<template>
  <div class="service-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            @click.prevent="exportCsv()"
            class="btn-color ml-4"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/2">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/2 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.services')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.services") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddServices' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('services', 'add')"
              >{{ $t("labels.add_service") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="services" class="permission">
        <template slot="thead">
          <!-- <vs-th>{{ $t('labels.serial_no') }}</vs-th> -->
          <vs-th class="col-md-3">{{ $t("labels.number") }}</vs-th>
          <vs-th class="col-md-6">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.id }}</vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td width="135">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  v-if="checkPermission('services', 'modify')"
                  @click="
                    $router.push({
                      name: 'EditServices',
                      params: { id: tr.id },
                    })
                  "
                ></vs-button>
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-if="checkPermission('services', 'delete')"
                >
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDisabled: true,
      services: [],
      index: -1,
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      search: null,
    };
  },
  watch: {
    limit(val) {
      // this.$store.state.limit = val
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getServices();
    },
    currentx(val) {
      this.getServices();
    },
  },
  // created() {
  //   this.limit = this.$store.state.limit
  // },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getServices();
  },
  methods: {
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteService,
      });
    },
    async deleteService() {
      if (this.index < 0) return;
      let url = "services/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.services[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getServices();
      }
    },
    // API Integration for listing services
    async getServices(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (exp) {
        this.exportFile(response, "Services");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.services = data.services;
        }
      }
    },
    exportCsv() {
      this.getServices(true);
    },
    filter() {
      this.getServices();
    },
    clearFilter() {
      this.search = null;
      this.getServices();
    },
  },
};
</script>
